export function routeToUrl(route: string): string {
  return `/${route}`;
}
